import pageRedirectMiddleware from './pageRedirectMiddleware';
import localeHandlingMiddleware from './localeHandlingMiddleware';

const routerMiddleware = [
    pageRedirectMiddleware,
    localeHandlingMiddleware
];

export default routerMiddleware;
